<div class="image">
  <img src="./assets/401.jpg">
  <div class="text" *ngIf="messageTypes == 2">
    Access - Denied
  </div>
  <div *ngIf="messageTypes == 3">
    <!-- <div class="main-text">
      PSNB access not present
    </div>
    <div class="text">
      Connect with your PSNB admin for access
    </div> -->
    <div class="main-text">
      PSNB Access Denied
    </div>
    <div class="text">
      Please reference the 'Single Application Support' <a href="https://etwiki.sys.comcast.net/pages/viewpage.action?spaceKey=WT&title=Support" target="_blank">link</a> for access
    </div>
  </div>
  <!-- <div *ngIf="messageTypes == 4">
    <div class="main-text">
      PSNB access not present
    </div>
    <div class="text">
      Connect with <a href="https://teams.microsoft.com/l/channel/19%3a521843133f864000ab10e035131736ae%40thread.tacv2/PSNB-UAT?groupId=04572cfd-94c1-4d20-a262-38fec6db90e4&tenantId=906aefe9-76a7-4f65-b82d-5ec20775d5aa" target="_blank">PSNB UAT</a> channel to get access
    </div>
  </div> -->
  <div *ngIf="messageTypes == 4">
    <div class="main-text">
      PSNB Access Denied
    </div>
    <div class="text">
      Please reference the 'Single Application Support' <a href="https://etwiki.sys.comcast.net/pages/viewpage.action?spaceKey=WT&title=Support" target="_blank">link</a> for access
    </div>
  </div>
</div>
